// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.ArrowUpThick = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.ArrowUpThick = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var ArrowUpThick = _exports.ArrowUpThick = function ArrowUpThick(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M9.11936 1.61621C9.60764 1.12793 10.4006 1.12793 10.8889 1.61621L17.1389 7.86621C17.4983 8.22559 17.6037 8.76074 17.4084 9.22949C17.2131 9.69824 16.76 10.0029 16.2522 10.0029H12.5022V17.1904C12.5022 18.0537 11.803 18.7529 10.9397 18.7529H9.06467C8.20139 18.7529 7.50217 18.0537 7.50217 17.1904V10.0029H3.75217C3.24827 10.0029 2.79124 9.69824 2.59592 9.22949C2.40061 8.76074 2.50999 8.22559 2.86546 7.86621L9.11546 1.61621H9.11936Z",
      fill: "currentColor"
    }));
  };
});
